import { IfpLoansDropdownWizardData as FormData } from '@sec-loans-ui/common/steps/assistance-step/components/ifp-loans-dropdown/IfpLoansDropdown'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, only, Suite, test } from 'vest'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: Partial<FormData>, changedFields?: FieldName<FormData>[]) => void> =>
  create((data, changedFields) => {
    only(changedFields)

    test('selectedLoanUuid', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.selectedLoanUuid).isNotUndefined()
      enforce(data.selectedLoanUuid).isNotEmpty()
    })
  })
